(() => {
  function initProduct() {
    const form = document.getElementById('vente-product-form');
    const data = document.getElementById('vente-variants-json');
    if (!form || !data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { console.error('VENTE variant data invalid', err); return; }
    if (!Array.isArray(variants)) return;
    const groups = [...form.querySelectorAll('.vente-choice[data-option-position]')]
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    const variantInput = document.getElementById('vente-variant-id');
    const button = document.getElementById('vente-add-to-cart');
    const status = document.getElementById('vente-variant-status');
    const price = document.getElementById('vente-product-price');
    const image = document.getElementById('vente-active-image');
    const variantOptions = v => Array.isArray(v.options) ? v.options.map(String) :
      [v.option1, v.option2, v.option3].filter(v => v !== null && v !== undefined).map(String);
    const selected = () => groups.map(g => g.querySelector('input:checked')?.value || null);
    const matches = (v, values) => variantOptions(v).length === values.length &&
      variantOptions(v).every((value, index) => value === values[index]);
    const exactVariant = values => variants.find(v => matches(v, values));
    const money = cents => {
      const currency = window.Shopify?.currency?.active || document.documentElement.dataset.currency;
      if (!currency) return null;
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100); }
      catch (e) { return null; }
    };
    function render() {
      const values = selected();
      groups.forEach((group, i) => {
        group.querySelectorAll('.vente-choice-label').forEach(label => {
          const radio = label.querySelector('input[type=radio]');
          const possible = values.slice();
          possible[i] = radio.value;
          // When another option is not yet selected, treat it as a wildcard.
          const available = variants.some(v => v.available && variantOptions(v).every((value, j) =>
            possible[j] === null || value === possible[j]));
          label.classList.toggle('is-unavailable', !available);
          radio.disabled = !available;
          label.setAttribute('aria-disabled', String(!available));
        });
      });
      const variant = exactVariant(values);
      const ready = Boolean(variant && variant.available);
      variantInput.value = ready ? String(variant.id) : '';
      button.disabled = !ready;
      button.textContent = ready ? 'ADD TO BAG' : variant ? 'SOLD OUT' : 'SELECT OPTIONS';
      if (groups.length === 0 || form.querySelector('.vente-missing-option')) {
        button.disabled = true;
        button.textContent = 'SELECT OPTIONS';
        status.textContent = 'Size and color must be configured as Shopify product variants before this item can be ordered.';
      } else {
        status.textContent = ready ? '' : variant ? 'This combination is sold out.' : 'Choose an available size and color.';
      }
      if (variant) {
        const formatted = money(variant.price);
        if (formatted && price) price.textContent = formatted;
        if (variant.featured_image?.src && image) image.src = variant.featured_image.src;
        if (window.history.replaceState) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url);
        }
      }
    }
    const requested = new URLSearchParams(location.search).get('variant');
    const initial = variants.find(v => String(v.id) === requested) ||
      variants.find(v => v.available) || variants[0];
    if (initial) {
      const values = variantOptions(initial);
      groups.forEach((group, i) => {
        const radio = [...group.querySelectorAll('input[type=radio]')].find(r => r.value === values[i]);
        if (radio) radio.checked = true;
      });
    }
    groups.forEach(group => group.addEventListener('change', event => {
      if (!event.target.matches('input[type=radio]')) return;
      const index = groups.indexOf(group);
      const chosen = selected();
      const exact = exactVariant(chosen);
      if (!exact || !exact.available) {
        // Preserve the customer's newly selected size/color and adjust other options
        // only when necessary to find a purchasable combination.
        const compatible = variants.find(v => v.available && variantOptions(v)[index] === chosen[index]);
        if (compatible) {
          const values = variantOptions(compatible);
          groups.forEach((g, i) => {
            if (i === index) return;
            const radio = [...g.querySelectorAll('input[type=radio]')].find(r => r.value === values[i]);
            if (radio) radio.checked = true;
          });
        }
      }
      render();
    }));
    form.addEventListener('submit', e => {
      if (!variantInput.value || button.disabled) e.preventDefault();
    });
    document.querySelectorAll('.product-thumb').forEach(thumb => thumb.addEventListener('click', () => {
      if (image) { image.src = thumb.dataset.image; image.alt = thumb.dataset.alt || ''; }
      document.querySelectorAll('.product-thumb').forEach(el => el.classList.toggle('is-active', el === thumb));
    }));
    const shades = {
      black:'#171717', schwarz:'#171717', white:'#f6f3ec', weiss:'#f6f3ec', weiß:'#f6f3ec',
      grey:'#777777', gray:'#777777', grau:'#777777', charcoal:'#444444',
      cream:'#e4ddd0', creme:'#e4ddd0', beige:'#cbb99e', navy:'#243248',
      blue:'#42678c', blau:'#42678c', brown:'#74513c', braun:'#74513c',
      red:'#a42f35', rot:'#a42f35', green:'#4a6b4b', grün:'#4a6b4b',
      olive:'#77754a', pink:'#c77e9b', purple:'#77548a', gold:'#b99a5c',
      silver:'#bcbec2', silber:'#bcbec2'
    };
    document.querySelectorAll('.vente-color-dot').forEach(dot => {
      const value = (dot.dataset.colorName || '').toLowerCase().trim();
      const match = Object.keys(shades).find(key => value === key || value.startsWith(key+' ') || value.endsWith(' '+key));
      dot.style.backgroundColor = shades[match] || '#8c847c';
    });
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProduct);
  else initProduct();
})();
